/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PortfolioEntity,
    PortfolioEntityFromJSON,
    PortfolioEntityFromJSONTyped,
    PortfolioEntityToJSON,
} from './PortfolioEntity';

/**
 * 
 * @export
 * @interface TradeImportLogEntity
 */
export interface TradeImportLogEntity {
    /**
     * 
     * @type {string}
     * @memberof TradeImportLogEntity
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof TradeImportLogEntity
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof TradeImportLogEntity
     */
    tradesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof TradeImportLogEntity
     */
    reverted: boolean;
    /**
     * 
     * @type {string}
     * @memberof TradeImportLogEntity
     */
    importerName: string;
    /**
     * 
     * @type {PortfolioEntity}
     * @memberof TradeImportLogEntity
     */
    portfolio: PortfolioEntity;
    /**
     * 
     * @type {string}
     * @memberof TradeImportLogEntity
     */
    portfolioId: string;
}

export function TradeImportLogEntityFromJSON(json: any): TradeImportLogEntity {
    return TradeImportLogEntityFromJSONTyped(json, false);
}

export function TradeImportLogEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeImportLogEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'tradesCount': json['tradesCount'],
        'reverted': json['reverted'],
        'importerName': json['importerName'],
        'portfolio': PortfolioEntityFromJSON(json['portfolio']),
        'portfolioId': json['portfolioId'],
    };
}

export function TradeImportLogEntityToJSON(value?: TradeImportLogEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': (value.date.toISOString()),
        'tradesCount': value.tradesCount,
        'reverted': value.reverted,
        'importerName': value.importerName,
        'portfolio': PortfolioEntityToJSON(value.portfolio),
        'portfolioId': value.portfolioId,
    };
}

